module.exports = __webpack_public_path__ + "static/bankshopper-699b70a97f9dc248bfacc8971e98841a.png";